import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaEventService } from '../../../services/ga-event.service';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { Override } from '../../../app-decorators';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { IDocumentType } from '../../../../main/bp-profiles/advanced/documents/bp-profiles-documents-data.service';
import { LOV_DOCTYPE, LovService } from '../../../services/lov.service';
import { FormattingService } from '../../../services/formatting.service';

interface IUpdateDocumentTypeModel {
  docType?:IDocumentType;
}

@Component({
  selector: 'update-document-type-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html',
  styleUrls: ['../report-actions.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateDocumentTypeActionComponent extends BaseReportActionsDialog implements OnInit {
  public model:IUpdateDocumentTypeModel = {};
  private documentTypeField:IExtraFieldConfigurationObject;

  constructor(
    private formlyService:GaFormlyService,
    private lovService:LovService,
    private formattingService:FormattingService,
    eventService:GaEventService,
    validateService:GaValidateService
  ) {
    super(eventService, validateService);
  }

  @Override(BaseReportActionsDialog)
  public ngOnInit():void {
    super.ngOnInit();

    // create fields
    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.documentTypeField = this.formlyService.aSelect('docType', 'Document type')
        .withFormat(this.formattingService.formatLov)
        .withExtraOptions({
          templateOptions: {
            trackBy: 'code'
          }
        })
        .isRequired()
        .build()
    ];
  }

  private fillFields():void {
    this.formlyService.fillField(this.documentTypeField, this.lovService.list(LOV_DOCTYPE));
  }
}